
import Enumerable from "linq";
import { Component, Mixins, Watch } from "vue-property-decorator";
import {
  IDrawableItem,
} from "../../../../domain/document/items";
import { EditingDocument } from "..";

// オブジェクト遅延描画Mixin.ライフサイクルフックやWatchを実装してるので、同一画面内では1つしか実装しないよう注意する事.
@Component({
})
export default class DocumentObjectLazyDrawableMixin extends Mixins() {
  editingSource: EditingDocument;
  drawableItemsOnPage: IDrawableItem[];

  data(): any {
    return {
      drawnItemCount: 0,  // data()実行タイミングではまだ$storeにアクセスできない？createdライフサイクルフックで初期化するので最初は0で.
    };
  }
  drawnItemCount: number;

  getInitialDrawItemCount(): number {
    return Math.min(
      this.drawableItemsOnPage ? this.drawableItemsOnPage.length : 0,
      this.configuration.initialDrawItemMax);
  }

  get configuration(): { initialDrawItemMax: number, intervalToDrawItemAsMsec: number, itemCountPerDraw: number, } {
    return this.$store.getters.configuration.behavior.document.editor.objectLazyDrawer;
  }

  get drawnItems(): IDrawableItem[] {
    return Enumerable.from(this.drawableItemsOnPage).take(this.drawnItemCount).toArray();
  }

  get isLazyDrawaing(): boolean {
    return (this.drawnItemCount < this.drawableItemsOnPage.length);
  }

  @Watch("currentSectionIndex")
  onDocumentObjectLazyDrawableCurrentSecionIndexChanged(newValue: number, oldValue: number): void {
    this.startDrawItems();    // 遅延描画対応.描画項目数を初期化する.
  }

  @Watch("drawableItemCount")
  onDocumentObjectLazyDrawableDrawableItemCountChanged(newValue: number, oldValue: number): void {
    // 項目追加/削除時対応.値を1変化させる事で描画更新が実行されるようにする.万一2以上の変化があった場合はupdatedでカウントアップされる.
    // Math.sign()はIE非対応なのでどろくさいけど下記実装で.
    if (oldValue < newValue) {
      this.drawnItemCount++;
    } else if (newValue < oldValue) {
      this.drawnItemCount--;
    }
  }

  created(): void {
    this.startDrawItems();    // 遅延描画対応.描画項目数を初期化する.
  }

  updated(): void {
    this.countUpDrawItems();  // 遅延描画対応.描画更新の度に描画項目数を増やす.
  }

  startDrawItems(): void {
    this.drawnItemCount = this.getInitialDrawItemCount();
    this.countUpDrawItems();
  }

  countUpDrawItems(): void {
    setTimeout(() => {
      if (this.drawnItemCount < this.drawableItemsOnPage.length) {
        this.drawnItemCount = Math.min(this.drawableItemsOnPage.length, this.drawnItemCount + this.configuration.itemCountPerDraw);
      }
    }, this.configuration.intervalToDrawItemAsMsec);
  }
}
